// FIX 2026-07-11: homepage 'Add to cart' buttons (.av-card-form) used to call
// fetch('/cart/add.js') directly with no event dispatch, so the item was added
// but the header cart link and drawer never found out. This dispatches both
// CartLinesUpdateEvent (for standard theme components) and a simple
// 'av:cart-changed' event with the new item_count (the custom AromaVista
// header listens for this to update the plain-text Cart (N) link, since that
// header has no other client-side reactivity at all).
import { CartLinesUpdateEvent } from '@shopify/events';

document.querySelectorAll('.av-card-form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const original = button.textContent;
    button.disabled = true;

    const formData = new FormData(form);
    const itemCount = Number(formData.get('quantity')) || 1;
    const deferred = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity: itemCount }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Cart add failed');

      const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const ajaxCart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('av:cart-changed', { detail: { item_count: ajaxCart.item_count } }));

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, source: 'av-card-form', itemCount, didError: false },
      });

      button.textContent = 'Added to cart ✓';
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      deferred.reject(error);
      button.textContent = 'View product';
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1800);
    }
  });
});
